import React, { useEffect, useState } from 'react';
import './Toast.css';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onUndo?: () => void;
  duration?: number;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'success',
  onUndo, 
  duration = 3000, 
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Fade in
    const fadeInTimer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Auto close after duration
    const closeTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, duration);

    return () => {
      clearTimeout(fadeInTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  const handleUndo = () => {
    if (onUndo) {
      onUndo();
    }
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for fade out animation
  };

  return (
    <div className={`toast toast-${type} ${isVisible ? 'toast-visible' : ''}`}>
      <div className="toast-content">
        <span className="toast-message">{message}</span>
        {onUndo && type !== 'error' && (
          <button 
            className="toast-undo-btn"
            onClick={handleUndo}
          >
            Undo
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast; 